import { useMemo } from 'react';

import _ from 'lodash';

import { SECTION_FORM_CONFIG_MAP } from '../../EditDrawer.config';
import { EMPTY_GROUPS_CONFIG } from '../Content.constants';

export const useSectionConfig = ({
  currentSection,
  isValidSection,
  attendantCompanyOptions,
  titleCompanyOptions,
  escrowCompanyOptions,
  onTitleCompanyChange,
  onEscrowCompanyChange,
  onChangeTitleLocation,
  onChangeEscrowLocation,
  hasTitleCompany,
  hasEscrowCompany,
  sellerAttorneyOptions,
  buyerAttorneyOptions,
  onSellerAttorneyChange,
  onBuyerAttorneyChange,
  hasSellerAttorney,
  hasBuyerAttorney,
  warehouseBankOptions,
  onFeeProviderChange,
  onOpenFeeProviderLocationTable,
  isChangeLocationButtonDisabled,
  isChangeLocationButtonVisible,
  onChangeAdvanceAmountPercentDependantField,
  isTwoPartClosing,
  borrowerVestingOptions,
  filteredMannerHeldOptions,
  isTrustSectionVisible,
  isBplLoanPurposeType,
  earliestClosingDate,
  currentCloseAt,
  currentNoteDate,
  businessDays,
  isUnsecured,
  isRescissionApplicable,
  isChattel,
  chattelFundingDate,
  manufacturedHomeContactsProps,
}) =>
  useMemo(() => {
    if (!isValidSection) {
      return EMPTY_GROUPS_CONFIG;
    }

    const configOrGetter = SECTION_FORM_CONFIG_MAP[currentSection];

    if (!configOrGetter) {
      return EMPTY_GROUPS_CONFIG;
    }

    return _.isFunction(configOrGetter)
      ? configOrGetter({
          attendantCompanyOptions,
          titleCompanyOptions,
          escrowCompanyOptions,
          onTitleCompanyChange,
          onEscrowCompanyChange,
          onChangeTitleLocation,
          onChangeEscrowLocation,
          hasTitleCompany,
          hasEscrowCompany,
          sellerAttorneyOptions,
          buyerAttorneyOptions,
          onSellerAttorneyChange,
          onBuyerAttorneyChange,
          hasSellerAttorney,
          hasBuyerAttorney,
          warehouseBankOptions,
          feeProviderOptions: attendantCompanyOptions,
          onFeeProviderChange,
          onOpenFeeProviderLocationTable,
          isChangeLocationButtonDisabled,
          isChangeLocationButtonVisible,
          onChangeAdvanceAmountPercentDependantField,
          isTwoPartClosing,
          borrowerVestingOptions,
          mannerHeldOptions: filteredMannerHeldOptions,
          isTrustSectionVisible,
          isMannerHeldDisabled: isTrustSectionVisible,
          isCompanyNameFieldVisible: true,
          isBplLoanPurposeType,
          earliestClosingDate,
          closeAt: currentCloseAt,
          hasCloseAt: !!currentCloseAt,
          hasNoteDate: !!currentNoteDate,
          businessDays,
          isUnsecured,
          isRescissionApplicable,
          isChattel,
          fundingDate: chattelFundingDate,
          ...manufacturedHomeContactsProps,
        })
      : configOrGetter;
  }, [
    currentSection,
    isValidSection,
    attendantCompanyOptions,
    titleCompanyOptions,
    escrowCompanyOptions,
    onTitleCompanyChange,
    onEscrowCompanyChange,
    onChangeTitleLocation,
    onChangeEscrowLocation,
    hasTitleCompany,
    hasEscrowCompany,
    sellerAttorneyOptions,
    buyerAttorneyOptions,
    onSellerAttorneyChange,
    onBuyerAttorneyChange,
    hasSellerAttorney,
    hasBuyerAttorney,
    warehouseBankOptions,
    onFeeProviderChange,
    onOpenFeeProviderLocationTable,
    isChangeLocationButtonDisabled,
    isChangeLocationButtonVisible,
    onChangeAdvanceAmountPercentDependantField,
    isTwoPartClosing,
    isBplLoanPurposeType,
    filteredMannerHeldOptions,
    borrowerVestingOptions,
    isTrustSectionVisible,
    earliestClosingDate,
    currentCloseAt,
    currentNoteDate,
    businessDays,
    isUnsecured,
    isRescissionApplicable,
    isChattel,
    chattelFundingDate,
    manufacturedHomeContactsProps,
  ]);
